
import LoginImage from "../../assets/Login/img-1.svg";
import LoginImage2 from "../../assets/Login/img-2 1.svg";
import color from "../../constants/color";


const styles = {
  main: {
    backgroundColor: "#F1F1F1",
    py: { xs: 4, sm: 4, md: 6 },
    height: "150vh",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  formSection: {
    textAlign: "center",
    mt:3
  },
  mobileGrid: {
    "& .MuiOutlinedInput-root": {
      height: "2.9em",
      marginTop: "0.5em",
      borderRadius: "10px",
      width: "100%",
    },
    ".react-tel-input": {
      width: "100%",
      "& .selected-flag": {
        "& .flag": {
          mt: "-9px",
        }
      },
      ".form-control": {
        borderRadius: "10px",
        mt: "7px",
        // height: "2.5em", // Match height with MUI input
        width: "100%",

      },
    },
  },

  select:{
    fontSize:"12px",
    fontWeight: "500", 
    
  },
  dropdown: {
    "& li.MuiButtonBase-root.MuiMenuItem-root.MuiMenuItem-gutters.MuiMenuItem-root.MuiMenuItem-gutters.css-10bz9go-MuiButtonBase-root-MuiMenuItem-root" : {
      fontSize:"12px",
      fontWeight: "500"
    }
  },
  formMain: {
    backgroundColor: "#F1F1F1",
    py: { xs: 4, sm: 3, md: 6 },
    alignItems: "center",
    height: { xs: "120vh", sm: "100vh", md: "95vh" },
    justifyContent: "center",
    display: "flex",
  },

  gridContainer: {
    alignItems: "center",
  },

  // root: {
  //   height: "100vh"
  // },
  formContain: {
    backgroundColor: "#fff",
  },
  dropDownMenu:{
    fontSize: "14px",
    color: "rgb(209 209 209)",
    fontWeight: "400"
  },
  menuPlaceholder: {
    color: "rgb(209 209 209)",

  },
  text: {
    color: "#D9D9D9",
    margin: "0 20%", // Adjust spacing as needed
  },
  mainheading: {
    mb: 1,
    fontWeight: 600,
    fontSize: "26px",
  },
  headingborder: {
    width: "20%",
    borderBottom: "3px solid #000",
    mb: 4,
  },
  checkbox: {
    color: "#00ABF4",
  },
  inputText: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#202020",
    mt: 1,
  },
  submit: {
    color: "white !important",
    borderRadius: 20,
    fontSize: "14px",
    fontWeight: "500",
    my: 2,
    py: 1,
    textAlign: "center",
    width: "fit-content",
    backgroundColor: "#000",
    textTransform: "none",
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator" :{
      position: "unset", 
    },
    "& .MuiButton-startIcon": {
      // marginRight: "8px", 
      marginLeft: "-8px", 
    },

  },

  container: {
    display: "flex",
    alignItems: "center",
  },
  boxStyle: {
    // position: 'absolute',
    backgroundColor: "#F1F1F1",
    py: { xs: 4, sm: 4, md: 6, lg: 7},
    height: {xs: "auto", sm: "auto", md: "120vh"},
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  paper: {
    borderRadius: 10,
    overflow: "hidden",
    boxShadow: "none",
    border: "1px solid #DEDEDE",

  },
  gridItem: {
    px: { xs: 3, sm: 5, lg: 7, },
    py: 4, 
    backgroundColor: "#fff", 
    borderRight: "1px solid #DEDEDE",

  },
  formGridItem: {
    px: { xs: 3, sm: 3, lg: 4, },
    py: 4, 
    backgroundColor: "#fff", 
    borderRight: "1px solid #DEDEDE",
    margin: "0 auto",
    borderRadius:"20px",

  },

  orSection: {
    alignItems: "center",
    justifyContent: "center",
    space: { xs: 3, sm: 3, lg: 10, xl: 10 },
  },
  orText: {
    color: "#878787",
    fontSize: "12px",
    fontWeight: "400",
  },
  divider: {
    color: "#D9D9D9",
  },
  orBox: {
    justifyContent: "center",
  },
  greyDot: {
    width: 5,
    height: 5,
    borderRadius: "50%",
    bgcolor: "grey",
    mx: 1,

  },
  privacyCondition: {
    mt: 3,
    color: "#878787",
    p: 0,
    // justifyContent: "center",
    display: "flex",
    // width: { sm: "90%", md: "90%", lg: "55%" },
    alignItems: "center",
    mb: 2,
  },
  termsText: {
    fontSize: "12px",
    fontWeight: "400",
    color: color.lightText,

  },
  greyText: {
    fontSize: "12px",
    fontWeight: "400",
    color: color.lightText,

  },
  flexInput: {
    width: {sx: "auto", sm:"49%"},
    fontSize: "12px",
    textAlign: "left",

    "& .css-1210n5w-MuiInputBase-root-MuiOutlinedInput-root .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input" :{
      fontSize: "12px",
      fontWeight: "500",
    },
  },
  flexInputs: {
    fontSize: "12px",
    textAlign: "left",

    "& .css-1210n5w-MuiInputBase-root-MuiOutlinedInput-root .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input" :{
      fontSize: "12px",
      fontWeight: "500",
    },
  },

  
  formfields: {
    display: {sx: "block", sm: "flex"},
    justifyContent: "space-between",
  },


  image: {
    // backgroundImage: `url("${LoginImage}")`,
    // backgroundSize: "cover",
    // backgroundRepeat: "no-repeat",
    // backgroundPosition: "center",
    // backgroundColor: "rgba(40, 170, 74, 0.2)",
    // px: { xs: 3, sm: 5, lg: 8, },
    // display: { xs: "none", sm: "block" },
    //  py: 2,
    justifyContent: "center",
    alignItems: "center",
    py: "10%",
    "& . css-1m9128y": {
      position: "absolute",
      bottom: 4
    },
  },
  backgroundImage: {
    backgroundImage: `url("${LoginImage}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height: "350px",
    width: "100%",
    // ml:"10% "
  },
  backgroundImage2: {
    backgroundImage: `url("${LoginImage2}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height: "350px",
    width: "100%",
    // ml:"10% "
  },

  sliderText: {
    my: "10%",
    px: 9,
    textAlign: "center",
    // mb: "3%",
    fontWeight: "500",
    fontSize: "12px",
  },

  dots: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    ml: "50%",
    // mb: "10%",
  },
  dot1: {
    width: "3%",
    height: "5px",
    backgroundColor: color.text,
    borderRadius: "30px",
    mx: "1%"
  },
  dot2: {
    width: "5px  ",
    height: "5px",
    backgroundColor: color.text,
    borderRadius: "30px"
  },
  image2: {
    backgroundImage: `url("${LoginImage2}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundColor: "rgba(40, 170, 74, 0.2)",
    // px: { xs: 3, sm: 5, lg: 8, },
    display: { xs: "none", sm: "block" },
    // py: 4,
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",

  },

  socialIcons: {
    marginTop: 3,
    marginBottom: 3,
  },

  icon: {
    marginRight: "10px",
    borderRadius: "50%",
    border: "1px solid #dedede",
    padding: "8px",
    height: "20px",
    width: "20px"

  },
  forgotlink: {

    color:color.text,
  },
  termsConditionText: {
    fontSize: "12px",
    fontWeight: "500",
  }


};

export default styles